export default "__VITE_ASSET__97c7f817__"